module.exports = __webpack_public_path__ + "img/widget_card.8e6829ee.svg";